import {getHtmlReportComponents} from "../ptsConstants";

export const getReportComponent = (reportType) => {
    const report = getHtmlReportComponents.find(f => f.name === reportType);
    return report ? report.component : null;
};